import AdminRoutes from '@/pages/admin/router';
import TeacherRoutes from '@/pages/teacher/router';
import StudentRoutes from '@/pages/student/router';
import UserRoutes from '@/pages/user/router';

export default [
	{
		path: '/',
		component: () => import('@/pages/components/Layout'),
		meta: {
			requiresAuth: true,
		},
		children: [
			...AdminRoutes,
			...TeacherRoutes,
			...StudentRoutes,
			...UserRoutes,
		]
	},
];
